<template>
  <div class="page--realtime_log">
    <div class="disconnected-wrap" v-if="connection_status == 'disconnected'">
      <div class="message"></div>
      <div class="action-wrap">
        <el-button @click="connect">{{ $t("button.reconnect") }}</el-button>
      </div>
    </div>
    <div class="cp-wrapper">
      <div class="cp" v-for="cp in cpFromData" @click="selectCp(cp)" :class="{ 'selected': selected_cps.includes(cp) }">{{ cp }}</div>
    </div>
    <div class="type-wrapper">
      <div class="type" v-for="type in typeFromData" @click="selectType(type)" :class="{ 'selected': selected_types.includes(type) }">{{ type }}</div>
    </div>
    <div class="chat-content">
      <div class="row" v-for="msg in filteredMessage">
        <div class="meta">
          <div class="to">{{ msg.to }}</div>
          <div class="type-wrap">
            <div class="type">{{ msg.type }}</div>
          </div>
        </div>
        <div class="inner-wrap">
          <div class="quick-summary">
            <div class="item" v-for="item in generateMessage(msg)" :style="`background:${item.bgColor}`">
              <div class="label">{{ item.label }}</div>
              <div class="value">{{ item.value }}</div>
            </div>
          </div>
          <div class="message-wrap">
            <div class="message">{{ msg.message }}</div>
            <div class="timestamp">{{ msg.timestamp ? $moment(msg.timestamp, 'x').format("HH:mm:ss") : "---" }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  mounted() {
    let el = document.querySelector(".chat-content");
    el.style = `height: ${el.clientHeight}px`;
    this.gconf = window.gconf;
    let refresh_interval = this.gconf.websocket.dashboard.refresh_interval && this.gconf.websocket.dashboard.refresh_interval > 500 ? this.gconf.websocket.dashboard.refresh_interval : 5000;
    this.interval = setInterval(this.connect, refresh_interval);
  },
  methods: {
    onMessage(event) {
      let data = JSON.parse(event.data);
      let message = JSON.parse(data.message);

      let type;
      let obj = {};
      if(message[0] == 2) {
        obj = message[3];
        if(message[2] == "DataTransfer") {
          type = obj.messageId;
        }else {
          type = message[2];
        }
      }
      this.messages.push({
        ...data,
        type,
        data: obj,
        timestamp: this.$moment().format('x'),
      });
      this.$forceUpdate();
      setTimeout(()=>{
        let el = document.querySelector(".chat-content > .row:last-child");
        el.scrollIntoView({behavior: "smooth", block: "end"});
      }, 50);
    },
    generateMessage(obj) {
      let highlight = [];
      switch(obj.type) {
        case "SetChargingProfile":
          highlight.push({
            label: "Limit",
            value: obj.data.csChargingProfiles.chargingSchedule.chargingSchedulePeriod[0].limit,
            bgColor: "#d77700"
          });
          break;
        case "queueingDetails":
          highlight.push({
            label: "QueuePos",
            value: obj.data.data.queueingPos,
            bgColor: "#00a6d7"
          });
          break;
      }
      return highlight;
    },
    selectCp(cp) {
      if(!this.selected_cps.includes(cp)) {
        this.selected_cps.push(cp);
      }else {
        this.selected_cps.splice(this.selected_cps.indexOf(cp), 1);
      }
    },
    selectType(type) {
      if(!this.selected_types.includes(type)) {
        this.selected_types.push(type);
      }else {
        this.selected_types.splice(this.selected_types.indexOf(type), 1);
      }
    },
    connect() {
      if(this.connection_status == "connected") return;
      if(this.leaved) return;
      try{
        this.connection = new WebSocket(`${this.$conf.api.BASE_WS_URL}/monitor`);
        this.connection_status = "connected";
        let vm = this;
        this.connection.onopen = function (event) {
          console.log("opened");
          vm.connection_status = "connected";
        };
        this.connection.onmessage = function(event) {
          vm.onMessage(event);
        };
        this.connection.onclose = function (event) {
          console.log("closed");
          vm.connection_status = "disconnected";
        }
        this.connection.onerror = function (event) {
          vm.$notify.error({
            title: 'Error',
            message: 'Websocket Error',
            position: 'top-left'
          });
          vm.connection_status = "disconnected";
          // vm.connected = false;
        }
      }catch(err) {
        this.$notify.error({
          title: 'Error',
          message: 'Websocket Connection Error',
          position: 'top-left'
        });
      }
    }
  },
  computed: {
    cpFromData() {
      let cps = this.messages.map(msg=>msg.to)
      return cps.filter((item, pos)=>cps.indexOf(item) == pos);
    },
    typeFromData() {
      let types = this.messages.map(msg=>msg.type)
      return types.filter((item, pos)=>types.indexOf(item) == pos);
    },
    filteredMessage() {
      let msgs = [];
      Object.assign(msgs, this.messages);
      if(this.selected_cps.length > 0) {
        msgs = msgs.filter(msg=>this.selected_cps.includes(msg.to));
      }
      if(this.selected_types.length > 0) {
        msgs = msgs.filter(msg=>this.selected_types.includes(msg.type));
      }

      return msgs;
    }
  },
  beforeDestroy() {
    this.leaved = true;
    if(this.interval) {
      clearInterval(this.interval);
    }
  },
  data() {
    return {
      connection_status: "unknown",
      leaved: false,
      messages: [],
      gconf: {},
      interval: false,
      selected_cps: [],
      selected_types: []
    }
  }
}
</script>

<style lang="scss">
.page--realtime_log{
  display: flex;
  flex-direction: column;
  .disconnected-wrap{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    z-index: 1;
    background: #999;
    opacity: .5;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .cp-wrapper,
  .type-wrapper{
    display: flex;
    // align-self: flex-start;
    align-items: center;
    height: 35px;
    margin-bottom: 5px;
    .cp,
    .type{
      background: #e9e9e9;
      display: flex;
      justify-content: center;
      align-items: center;
      align-self: flex-start;
      margin-left: 5px;
      padding: 2px 5px;
      border-radius: 5px;
      cursor: pointer;
      &.selected{
        background: #aaa;
      }
    }
  }
  .chat-content{
    flex-grow: 1;
    overflow-y: auto;
    .row{
      margin-bottom: 10px;
      display: flex;
      border-bottom: 1px solid #ddd;
      .meta{
        margin-right: 10px;
        display: flex;
        .to{
          font-size: 14px;
          width: 100px;
        }
        .type-wrap{
          width: 120px;
          display: flex;
          .type{
            font-size: x-small;
            color: white;
            background: #333;
            padding: 2px 7px;
            border-radius: 5px;
            display: inline-block;
            // width: 100px;
            align-self: flex-start;
            text-align: center;
          }
        }
      }
      .inner-wrap{
        flex-grow: 1;
        width: 100%;
        display: flex;
        .quick-summary{
          width: 100px;
          display: flex;
          .item{
            display: flex;
            font-size: small;
            background: #e1e1e1;
            color: white;
            padding: 2px 7px;
            border-radius: 5px;
            align-self: flex-start;
            .label{
              margin-right: 5px;
            }
            .label,
            .value{
              display: inline-block;
            }
          }
        }
        .message-wrap{
          width: 70%;
          flex-grow: 1;
          
          // margin-bottom: 5px;
          
          word-break: break-all;
          font-size: small;
        }
        .message{
          background: #e1e1e1;
          padding: 5px 10px;
          border-radius: 5px;
        }
        .timestamp{
          text-align: right;
          color: #999;
        }
      }
    }
  }
}
</style>